import React, { useState, useEffect, useContext } from 'react';
import { ExternalLink } from 'lucide-react';
import axios from 'axios';
import { AuthContext } from '../App';

/**
 * Mobile-only horizontal banner strip — shown below job listings on small screens
 * Hidden on sm+ (desktop shows the BannerSidebar instead)
 */
const BannerMobileStrip = () => {
  const { API, user } = useContext(AuthContext);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetchBanners();
  }, [user]);

  const fetchBanners = async () => {
    try {
      const res = await axios.get(`${API}/ads/active`);
      setBanners(res.data.banners || []);
    } catch { /* silent fail */ }
  };

  const trackClick = (bannerId) => {
    try {
      axios.post(`${API}/ads/${bannerId}/click`).catch(() => {});
    } catch {}
  };

  const fallback = [{
    id: 'fb-1', title: 'GKV Consulting', description: 'Professional consulting in Switzerland',
    bg_color: '#1e3a5f', text_color: '#ffffff', link_url: 'https://www.gkv-consulting.com'
  }];

  const display = banners.length > 0 ? banners : fallback;

  return (
    <div className="sm:hidden mt-6" data-testid="banner-mobile-strip">
      <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-2 px-1">Sponsored</p>
      <div className="grid max-w-full grid-cols-1 gap-3 pb-2">
        {display.map((banner) => (
          banner.link_url ? (
            <a
              key={banner.id}
              href={banner.link_url}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full max-w-full rounded-xl overflow-hidden shadow-sm cursor-pointer active:opacity-80"
              style={{ backgroundColor: banner.bg_color || '#2563eb' }}
              onClick={() => trackClick(banner.id)}
              data-testid={`mobile-banner-${banner.id}`}
            >
              {banner.image_url && (
                <img
                  src={banner.image_url}
                  alt={banner.title}
                  className="w-full h-16 object-cover"
                  onError={e => { e.target.style.display = 'none'; }}
                />
              )}
              <div className="px-3 py-2.5" style={{ color: banner.text_color || '#ffffff' }}>
                <p className="font-semibold text-sm leading-tight">{banner.title}</p>
                {banner.description && (
                  <p className="text-xs mt-0.5 opacity-80 line-clamp-2">{banner.description}</p>
                )}
                <span className="inline-flex items-center gap-1 text-xs mt-1.5 opacity-70">
                  <ExternalLink className="w-2.5 h-2.5" />
                  Learn more
                </span>
              </div>
            </a>
          ) : (
            <div
              key={banner.id}
              className="w-full max-w-full rounded-xl overflow-hidden shadow-sm"
              style={{ backgroundColor: banner.bg_color || '#2563eb' }}
              data-testid={`mobile-banner-${banner.id}`}
            >
              {banner.image_url && (
                <img
                  src={banner.image_url}
                  alt={banner.title}
                  className="w-full h-16 object-cover"
                  onError={e => { e.target.style.display = 'none'; }}
                />
              )}
              <div className="px-3 py-2.5" style={{ color: banner.text_color || '#ffffff' }}>
                <p className="font-semibold text-sm leading-tight">{banner.title}</p>
                {banner.description && (
                  <p className="text-xs mt-0.5 opacity-80 line-clamp-2">{banner.description}</p>
                )}
              </div>
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default BannerMobileStrip;
